import React, {useState} from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import LeadForm from "./LeadForm";
import LeadSuccess from "./LeadSuccess";
function App({
    formTypes,
    drives,
    countries,
    navigationAreas,
    models,
    dealerObjects,
    salesPersonObjects,
    lead,
    event,
    variant,
    brokers,
    tourUsers,
    doubleOptin
}){

    return (
            <Router>
                <Switch>
                    <LeadForm
                        path="/"
                        drives={drives}
                        countries={countries}
                        navigationAreas={navigationAreas}
                        models={models}
                        dealerObjects={dealerObjects}
                        lead={lead}
                        event={event}
                        salesPersonObjects={salesPersonObjects}
                        variant={variant}
                        brokers={brokers}
                        tourUsers={tourUsers}
                        signature={false}
                        doubleOptin={doubleOptin !== false}
                    />
                </Switch>
            </Router>
    );
};

export default App;
